import { ArrowSquareOut } from "@phosphor-icons/react";
import { stageLabel } from "../../../lib/constants";
import { ReturnTracker } from "../PortalSections";
import { DeadlineCalendar } from "../../DeadlineCalendar";
import { ScenarioCalculator } from "../ScenarioCalculator";

// Tax & Filings tab: current-year return status, list of active tax engagements
// (each opens the ServiceDrawer overlay), deadline calendar, and a what-if calculator.
export default function TaxTab({ data, extras, onOpenService }) {
  return (
    <div className="space-y-6" data-testid="portal-panel-tax">
      <ReturnTracker tracker={extras?.tracker} refundLinks={extras?.refund_links} />
      <div className="rounded-lg border border-zinc-200 bg-white p-5">
        <h3 className="text-sm font-medium text-zinc-900 mb-3">Your active tax engagements</h3>
        {!(data?.engagements || []).length && <p className="text-xs text-zinc-400 italic">No active tax engagements yet.</p>}
        <div className="space-y-2">
          {(data?.engagements || []).map((e) => (
            <button key={e.id} data-testid={`tax-engagement-${e.id}`}
              onClick={() => onOpenService?.({ engagement_id: e.id, service_type: e.service_type, tax_year: e.tax_year, slug: "tax-strategy", title: `${e.service_type} · Tax Year ${e.tax_year}`, category: "tax" })}
              className="w-full text-left flex items-center justify-between border border-zinc-200 hover:border-zinc-900 rounded-md px-3 py-2.5 transition-colors duration-150">
              <div>
                <p className="text-sm font-medium text-zinc-900">Form {e.service_type} · Tax year {e.tax_year}</p>
                <p className="text-[10px] text-zinc-500">Stage: {stageLabel(e.stage)}</p>
              </div>
              <ArrowSquareOut size={13} className="text-zinc-400" />
            </button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <DeadlineCalendar compact />
        <ScenarioCalculator />
      </div>
    </div>
  );
}
